import PropTypes from 'prop-types';
import React from 'react';

const blockScreenClass = isScreenBlocked => `${isScreenBlocked ? ' block-screen' : ''}`;

const greyOutScreenClass = isGreyedOut => `${isGreyedOut ? ' disabled-measure' : ''}`;

const PassageLayout = props => (
    <div
        className={
            `assessment-window ${props.class}` +
            `${blockScreenClass(props.isScreenBlocked)}` +
            `${greyOutScreenClass(props.isGreyedOut)}`
        }
    >
        <div className="fluency-background" />
        {props.children}
    </div>
);

PassageLayout.propTypes = {
    children: PropTypes.node,
    isScreenBlocked: PropTypes.bool,
    isGreyedOut: PropTypes.bool,
    class: PropTypes.string,
};

PassageLayout.defaultProps = {
    children: undefined,
    isScreenBlocked: false,
    isGreyedOut: false,
    class: '',
};

export default PassageLayout;
